<template>
  <div class="appSharePage">
    <div class="appShareHeader">
      <div class="appShareTitle">
        <div class="logoIconC">
          <img :src="logoIcon" class="logoIconMini" />
        </div>
        <div>
          <p>咨询一体化APP</p>
          <p class="appShareTitleDesc">专业法律服务平台</p>
        </div>
      </div>
      <div class="appShareTitleDetail">
        <h2 class="appShareTitleDetailMain">在线律师咨询</h2>
        <p class="appShareTitleDetailDesc">持证律师在线，图文/电话答疑</p>
      </div>
    </div>
    <div class="appShareContent">
      <!-- 微信内置浏览器提示条 -->
      <div class="appShareCard" id="wechatTip" v-if="isWechat">
        <div class="wechatTip">
          <i class="fa fa-info-circle mr10"></i>当前在微信内无法直接下载，请点击右上角【···】→在浏览器打开
        </div>
      </div>

      <div class="appShareCard" v-else>
        <!-- 核心下载二维码区域 -->
        <section>
          <Carousel :autoplay-speed="3000" autoplay loop>
            <CarouselItem :key="idx+'banner'" v-for="(banner, idx) in banners">
              <img :src="banner.url" height="auto" width="100%" />
            </CarouselItem>
          </Carousel>

          <!-- 下载按钮组 -->
          <div class="btnContainer">
            <div :key="item.code" v-for="item in downloadList">
              <Button
                :type="item.code=='ios'?'success':'primary'"
                @click="download(item)"
                style="width: 260px; margin: 10px; height: auto;"
              >
                <div class="btnItem">
                  <span :class="item.code+'Icon'"></span>
                  <span>{{item.name }}下载</span>
                </div>
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="appShareFooter">
      <p>©2026 上海法烙科技有限公司 版权所有</p>
    </div>
    <div class="detail">
      <div>
        <a @click="viewFWXY" href="javascript:void(0)">用户协议</a>
      </div>
      <!-- <span class="mx-2">|</span> -->
      <div>
        <a @click="viewYSZC" href="javascript:void(0)">隐私政策</a>
      </div>
      <!-- <span class="mx-2">|</span> -->
      <div>
        <div>沪ICP备2025137942号-2A</div>
      </div>
    </div>

    <!-- <div class="imgContainer"></div> -->

    <Modal @on-cancel="cancelFWXY" footer-hide title="服务协议" v-model="fyxyView" width="50vw">
      <div class="fileContainer">
        <div class="fileTitle">服务协议</div>
        <div v-html="pageHtml"></div>
      </div>
    </Modal>

    <Modal @on-cancel="cancelYSZC" footer-hide title="隐私政策" v-model="yszcView" width="70vw">
      <div class="fileContainer">
        <div class="fileTitle">隐私政策</div>
        <div v-html="pageHtml"></div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'appDownload',
  data () {
    return {
      yszcView: false,
      fyxyView: false,
      pageHtml: '',
      logoIcon: require('@/assets/static/images/logo_mini.png'),
      baseInfo: [],
      downloadList: [],
      isWechat: false,
      isAndroid: false,
      isIOS: false,
      banners: [
        {
          url: require('@/assets/static/images/app/a.png')
        },
        {
          url: require('@/assets/static/images/app/b.png')
        },
        {
          url: require('@/assets/static/images/app/c.png')
        },
      ]
    }
  },
  methods: {
    viewFWXY: function () {
      this.getPageData('serviceAgreement')
      this.fyxyView = true
    },
    viewYSZC: function () {
      this.getPageData('privacyPolicy')
      this.fyxyView = true
    },
    cancelFWXY: function () {
      this.fyxyView = false
      this.pageHtml = ''
    },
    cancelYSZC: function () {
      this.yszcView = false
      this.pageHtml = ''
    },

    getPageData: function (pageType) {
      let params = new this.$URLSearchParams()
      params.append("pageType", pageType)
      this.$axiosH5.post('/appBaseSupport/pageData', params).then(res => {
        if (res.success) {
          let result = (res.result || {}).data
          this.pageHtml = result?.detail
          //解析HTML用到了插件mp-html,更多文档见：https://jin-yufeng.gitee.io/mp-html/#/overview/quickstart
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getDownloads: function () {
      let that = this
      that.$axiosH5.post(that.$apis.common.getAPPDownloads).then(res => {
        if (res.success) {
          that.downloadList = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("操作失败！")
      })
    },
    download: function (data) {
      window.location.href = data.downUrl
    },
    loadBaseInfo: function () {
      let that = this
      that.$axios.post('/loginInfo').then(res => {
        if (res.success) {
          let data = res.result || {}
          this.baseInfo = data.projectInfo || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log("loadBaseInfo err", err)
        // that.$Message.error('获取失败！');
      })
    },
  },
  beforeMount () {
    this.loadBaseInfo()
    // 环境判断
    const ua = navigator.userAgent.toLowerCase()
    const isWechat = ua.match(/MicroMessenger/i) == "micromessenger"
    const isIOS = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
    const isAndroid = ua.indexOf("android") > -1

    const wechatTip = document.getElementById('wechatTip')
    const btnAndroid = document.getElementById('btnAndroid')
    const btnIos = document.getElementById('btnIos')
    const bottomDownloadBtn = document.getElementById('bottomDownloadBtn')

    // 微信环境显示提示
    if (isWechat) {
      // wechatTip.classList.remove('hidden')
      // // 微信内禁止直接跳转下载
      // btnAndroid.href = "javascript:alert('请在浏览器打开后下载')"
      // btnIos.href = "javascript:alert('请在浏览器打开后下载')"
      // bottomDownloadBtn.href = "javascript:alert('请点击右上角···，在浏览器打开页面下载APP')"
    }

    // 根据设备高亮对应按钮
    // if (isAndroid && !isWechat) {
    //   btnAndroid.classList.add('ring-2', 'ring-primaryLight')
    // } else if (isIOS && !isWechat) {
    //   btnIos.classList.add('ring-2', 'ring-gray-400')
    // }

    // 二维码弹窗
    // const qrcodeBox = document.getElementById('qrcodeBox')
    // const qrcodeModal = document.getElementById('qrcodeModal')
    // const closeModal = document.getElementById('closeModal')
    // qrcodeBox.onclick = () => qrcodeModal.classList.remove('hidden')
    // closeModal.onclick = () => qrcodeModal.classList.add('hidden')
    // qrcodeModal.onclick = (e) => {
    //   if (e.target === qrcodeModal) qrcodeModal.classList.add('hidden')
    // }

    // // FAQ展开收起
    // document.querySelectorAll('.faq-title').forEach(item => {
    //   item.onclick = function () {
    //     const content = this.nextElementSibling
    //     const icon = this.querySelector('i')
    //     content.classList.toggle('hidden')
    //     icon.classList.toggle('rotate-180')
    //   }
    // })

    this.getDownloads()
  }
}
</script>
<style lang="less" scoped>
.appSharePage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f7f8fa;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // background-image: url('@/assets/static/images/app/bg@2x.png');
  // background-position: center;
  // background-size: 100% 100%;
  // background-repeat: no-repeat;

  .appShareHeader {
    // height: 200px;
    // background: #296cff;
    background: linear-gradient(60deg, #296cff, #5cadff);
    padding: 1.6rem 1.2rem;

    .appShareTitle {
      align-items: center;
      line-height: normal;
      font-weight: 700;
      font-style: normal;
      font-size: 1.4rem;
      display: flex;
      color: #fff;
      text-align: left;

      .appShareTitleDesc {
        font-size: 1rem;
        font-weight: normal;
      }

      .logoIconC {
        width: 4rem;
        height: 4rem;
        margin-right: 10px;
        background: #fff;
        border-radius: 5px;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .appShareTitleDetail {
      color: #fff;
      margin-top: 1rem;

      .appShareTitleDetailMain {
        font-size: 1.2rem;
      }

      .appShareTitleDetailDesc {
        font-size: 1rem;
        margin-top: 4px;
      }
    }
  }

  .appShareContent {
    padding: 1rem;
    flex-grow: 1;
    overflow-y: auto;
  }

  .appShareCard {
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    position: relative;
  }

  .appShareFooter {
    // background: #fff;
    text-align: center;
    padding: 0 8px;
    font-size: 12px;
  }

  .detail {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #888;
    font-size: 13px;

    > div {
      padding: 0 10px;
      line-height: 2rem;
      position: relative;

      a {
        color: #888;
        text-decoration: underline;
        text-underline-offset: 3px;
      }
    }

    > div:not(:last-child)::after {
      content: '';
      width: 2px;
      height: 1rem;
      background: #ddd;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
}

// .imgContainer {
//   background-image: url('@/assets/static/images/app/pic@2x.png');
//   background-position: center;
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
//   position: absolute;
//   width: 86vw;
//   max-width: 400px;
//   height: 88vw;
//   max-height: 460px;
//   left: 0;
//   right: 0;
//   margin: auto;
//   top: 10%;
// }

.btnContainer {
  text-align: center;
}

.btnItem {
  flex: 1;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  height: 2.6rem;
}

.iosIcon {
  margin: auto 8px;
  width: 1.8rem;
  height: 1.8rem;
  background-image: url('@/assets/static/images/app/apple.png');
  background-repeat: no-repeat;
  display: inline-block;
  background-position: center;
  background-size: 100% 100%;
}

.androidIcon {
  margin: auto 8px;
  width: 1.8rem;
  height: 1.8rem;
  background-image: url('@/assets/static/images/app/android.png');
  display: inline-block;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.fileContainer {
  word-wrap: break-word;
  user-select: none;
  max-height: 70vh;
  overflow-y: auto;
  font-family: 'Microsoft YaHei', SimHei, sans-serif;
  max-width: 600px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 1rem;

  .fileTitle {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .filePre {
    margin: 10px 0;
  }

  .filePart {
    margin: 10px 0;
    .filePartTitle {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 6px;
    }

    .filePartContent {
      font-size: 0.9rem;
    }
  }
}
</style>